/**
 * Kontakt-IDs mit eigener Zustellung (leads.shopify_versand = false) — für
 * Rozetten in Bestell-/Lagerlisten. Fehlt die Spalte (Migration offen),
 * bleibt die Menge leer und alles verhält sich wie bisher.
 */
import { useQuery } from '@tanstack/react-query';
import { initSupabase } from '@/api/adapters/SupabaseAdapter';

export const EIGENE_ZUSTELLUNG_KEY = ['eigene-zustellung-leads'];

export function useEigeneZustellung() {
  const { data } = useQuery({
    queryKey: EIGENE_ZUSTELLUNG_KEY,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const sb = initSupabase();
      if (!sb) return new Set();
      const { data: rows, error } = await sb.from('leads').select('id').eq('shopify_versand', false);
      if (error) return new Set();
      return new Set((rows || []).map((r) => r.id));
    },
  });
  return data || new Set();
}
